import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { SubscriptionGuard } from './subscription.guard';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })

export class PlanStarterGuard implements CanActivate {
  constructor(private subGuard: SubscriptionGuard) {}
  canActivate(): Observable<boolean> {
    return this.subGuard.hasMinimumLevel('starter');
  }
}
